import React, {useCallback, useEffect, useRef, useState} from 'react';
import {FileUpload} from 'primereact/fileupload';
import PropTypes from 'prop-types';
import ActionLink from '../ActionLink';
import ImageUtils from '../../utils/ImageUtils';
import FileUploadService from '../../services/FileUploadService';
import {t} from 'i18next';
import StringUtils from '../../utils/StringUtils';

export const ImageComponent = (props) => {
    const {
        viewMode,
        srcUrl,
        alt,
        required,
        reqiredLabel,
        validator,
        style,
        errorMessage,
        setFile,
        notValidImageTypeErrorMessage,
        attachment,
        handleRemove,
        className,
        imgMaxSizeParameter,
        fileSizeToTranslation,
        id,
        labelStyle,
    } = props;

    const [selectedFile, setSelectedFile] = useState(null);
    const fileUploadRef = useRef(null);
    const fileUploadService = new FileUploadService();

    const validateFileField = useCallback(() => {
        if (required) {
            validator.message('image', 'label', selectedFile, 'required');
        }
    }, [required, selectedFile, validator]);

    const onSelect = (e) => {
        const file = e.files[0];
        setSelectedFile(file);
        validateFileField();
        uploadHandler(file);
    };

    const onClear = () => {
        setSelectedFile(null);
        validateFileField();
    };

    useEffect(() => {
        validateFileField(); // Upewnij się, że walidacja jest aktualizowana przy zmianie pliku
    }, [selectedFile, validateFileField]);

    const uploadHandler = async (file) => {
        const formData = new FormData();
        if (file) {
            formData.append('file', file);
            if (ImageUtils.notValidImageFormat(file)) {
                if (notValidImageTypeErrorMessage) {
                    notValidImageTypeErrorMessage();
                }
                fileUploadRef.current.clear();
                return;
            }
            fileUploadService
                .uploadAttachemnt(formData)
                .then((uploadedFile) => {
                    setFile(uploadedFile);
                })
                .catch((err) => {
                    errorMessage(err.message);
                    setSelectedFile(null);
                    setFile(null);
                });
        }
    };

    return attachment || viewMode === 'VIEW' ? (
        <div className='col-lg-12'>
             {props.label !== undefined ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%', ...labelStyle}}>
                               {props.label}
                            </label>
                        ) : ''}
            {!StringUtils.isBlank(attachment) ? (
                <img src={srcUrl} alt={alt} className='product-image' style={style || {height: '150px', width: 'auto'}} />
            ) : (
                'Brak loga'
            )}

            {viewMode !== 'VIEW' ? (
                <ActionLink
                    className='p-link float-right'
                    handleClick={handleRemove}
                    variant='red'
                    iconName='mdi-trash-can'
                    iconSide='left'
                    iconSize='xl'
                    iconColor='red'
                    iconStyle={{fontSize: '35px', marginTop: 0}}
                />
            ) : null}
        </div>
    ) : (
        <>
        {props.label !== undefined ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%', ...labelStyle}}>
                                {props.label}
                            </label>
                        ) : ''}
            <FileUpload
                id={id}
                ref={fileUploadRef}
                uploadLabel={t('file.upload')}
                chooseLabel={t('file.choose')}
                cancelLabel={t('file.cancel')}
                multiple={false}
                customUpload
                uploadOptions={{className: 'hidden'}}
                cancelOptions={{className: 'hidden'}}
                onSelect={onSelect}
                onRemove={onClear}
                onClear={onClear}
                disabled={viewMode === 'VIEW'}
                accept='image/*'
                className={`fileupload-component ${className}`}
                maxFileSize={imgMaxSizeParameter}
                invalidFileSizeMessageSummary={t('global.invalidFileSizeSummary')}
                invalidFileSizeMessageDetail={t('global.invalidFileSizeDetails') + fileSizeToTranslation}
            />
            {required && validator?.messagesShown && !selectedFile && (
                <div aria-live='assertive' style={{color: 'tomato', fontSize: '13px'}}>
                    {reqiredLabel}
                </div>
            )}
        </>
    );
};

ImageComponent.defaultProps = {
    required: false,
    reqiredLabel: 'Pole wymagane',
    id: 'image',
};

ImageComponent.propTypes = {
    validator: PropTypes.object,
    required: PropTypes.bool,
    id: PropTypes.string,
    reqiredLabel: PropTypes.string,
    label: PropTypes.string,
    labelStyle: PropTypes.object,
};

export default ImageComponent;
